const childrenLoaded = require("@alexspirgel/children-loaded");
import Splide from '@splidejs/splide';

class Testimonial extends HTMLElement {
    constructor() {
        super();
    }

    async connectedCallback() {
        await childrenLoaded(this);
        if (this.getAttribute('data-is-preview') == "1") {
            return;
        }
        new Splide(this, {type: 'fade', rewind: true}).mount();
    }
}

customElements.define('block-testimonials', Testimonial, {extends: 'section'});